import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import ApiError from '@/lib/shared-coms/ApiError';
import { Spinner } from 'equasion-lib';
import { BULK_INVENTORY_EVENT_CREATE } from '@/lib/graphql/fragments';
import Stock from './Stock';
import { useRootStore } from '@/lib/providers/RootProvider';
import { readScannedLot } from '@/lib/scanning/scannedLot';

const SERIALIZED_ITEM_STATE = gql`
  query serializedItemState($serialNumber: String!, $gtin: String, $companyId: ID!) {
    serializedItemState(serialNumber: $serialNumber, gtin: $gtin, companyId: $companyId) {
      status
      lot
      expiration
      serialNumber
      gtin
      serializedItemType
      product {
        id
      }
      purchaseOrder {
        id
        clientPurchaseOrderNumber
        # EPCIS overage notice + running count (see ./stockOverage.ts)
        stockingProgress {
          productId
          orderedQuantity
          stockedQuantity
          epcisQuantity
          overageQuantity
          product {
            id
            title
          }
        }
        vendor {
          id
          companyName
          billingAddress {
            lineOne
            lineTwo
            city
            state
            zipCode
          }
        }
      }
      pedigree {
        SSCC
        CA
        PK
        ITEM
      }
      itemBreakdown {
        quantity
        status
        lot
        expiration
        product {
          id
          title
          fdaProduct {
            id
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
    }
  }
`;

function StockData(props) {
  const selectedCompanyId = useRootStore((state) => state.selectedCompany?.id);
  const [bulkInventoryEventCreate] = useMutation(BULK_INVENTORY_EVENT_CREATE);
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get('serialNumber');
  const gtin = searchParams.get('gtin');
  const scannedLot = readScannedLot(searchParams);

  const { data, error, loading } = useQuery(SERIALIZED_ITEM_STATE, {
    variables: { serialNumber, gtin, companyId: selectedCompanyId }
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { serializedItemState } = data || {};

  return (
    <Stock
      serializedItemState={serializedItemState}
      bulkInventoryEventCreate={bulkInventoryEventCreate}
      selectedCompanyId={selectedCompanyId}
      scannedLot={scannedLot}
      {...props}
    />
  );
}

export default StockData;
